import React from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import copy from "copy-to-clipboard";
import Cookies from "js-cookie";
import spinner from "../images/spinner.gif";
import "./Dashboard.css";
import {
  checkUser,
  handleSignOut,
  updateAvatar,
  updateUsername,
  updateFullname,
} from "../utils/database";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightFromBracket,
  faInbox,
  faPenToSquare,
  faCheck,
  faLink,
} from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


function Dashboard() {
  const navigate = useNavigate();
  const [text, setText] = useState("");
  const [logged, setLogged] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userdata, setUserdata] = useState({});
  const [avatar, setAvatar] = useState(spinner);
  const [appearInput, setAppearInput] = useState(0);

  const accessToken = Cookies.get("accessToken");
  const accessTokenSecret = Cookies.get("accessTokenSecret");
  const accessProvider = Cookies.get("accessProvider")
  if(accessProvider == undefined){
    Cookies.remove("accessToken", { path: "" });
    Cookies.remove("accessTokenSecret", { path: "" });
  }
  useEffect(() => {
    checkUser(accessProvider,accessToken, accessTokenSecret)
      .then((result) => {
        if (result) {
          document.title = "@" + result.username + " dashboard";
          setLogged(true);
          setUserdata(result);
          setAvatar(spinner);
          setAvatar(result.avatarUrl);
        }
      })
      .finally(() => setLoading(false));
  }, []);
  function handleLogOut() {
    handleSignOut().then(() => navigate("/login"));
  }

  function handleChangeAvatar(file) {
    setAvatar(spinner);
    updateAvatar(userdata.uid, file).then((url) => {
      setAvatar(url);
      toast.success("Avatar changed!");
    });
  }

  function handleChangeUsername(e) {
    e.preventDefault();
    updateUsername(userdata.uid, e.target[0].value).then((result) => {
      userdata.username = e.target[0].value;
      setUserdata(userdata);
      setAppearInput(0);
    });
  }

  function handleChangeFullname(e) {
    e.preventDefault();
    updateFullname(userdata.uid, e.target[0].value).then((result) => {
      userdata.fullName = e.target[0].value;
      setUserdata(userdata);
      setAppearInput(0);
    });
  }

  function copyLink() {
    copy(window.location.host + "/" + userdata.uid);
    toast.success("Copied link!");
  }

  return (
    <>
      <div className="container">
        {loading ? (
          <div className="spinner">
            <img src={spinner} />
          </div>
        ) : logged ? (
          <>
            <ToastContainer
              position="top-center"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover={false}
              theme="light"
            />
            <div className="container-user">
              <nav>
                <button
                  onClick={() => handleLogOut()}
                  className="button logout"
                >
                  <FontAwesomeIcon icon={faArrowRightFromBracket} size="lg" />
                  Log Out
                </button>
                <div>
                  <button
                    className="button copy-link"
                    onClick={() => copyLink()}
                  >
                    <FontAwesomeIcon icon={faLink} />
                    Copy url
                  </button>
                  <button
                    className="button inbox"
                    onClick={() => navigate("/inbox")}
                  >
                    <FontAwesomeIcon icon={faInbox} size="lg" />
                    Inbox
                  </button>
                </div>
              </nav>
              <div className="user-info">
                <label className="profile-picture" htmlFor="input-avatar">
                  <img src={avatar} width={97} height={97} />
                  <div className="edit-icon">
                    <FontAwesomeIcon
                      icon={faPenToSquare}
                      size="lg"
                      color="white"
                    />
                  </div>
                  <input
                    type="file"
                    id="input-avatar"
                    accept="image/png, image/jpeg"
                    onChange={(e) => handleChangeAvatar(e.target.files[0])}
                  />
                </label>
                <div className="profile profile-username">
                  {appearInput == 1 ? (
                    <form method="get" onSubmit={(e) => handleChangeUsername(e)}>
                      @
                      <input
                        type="text"
                        defaultValue={userdata.username}
                        onChange={(e) => setText(e.target.value)}
                      />
                      <button type="submit">
                        <FontAwesomeIcon icon={faCheck} />
                      </button>
                    </form>
                  ) : (
                    <>
                      @{userdata.username}
                      <button onClick={() => setAppearInput(1)}>
                        <FontAwesomeIcon icon={faPenToSquare} />
                      </button>
                    </>
                  )}
                </div>
                <div className="profile profile-fullname">
                  {appearInput == 2 ? (
                    <form onSubmit={(e) => handleChangeFullname(e)}>
                      <input
                        type="text"
                        defaultValue={userdata.fullName}
                        onChange={(e) => setText(e.target.value)}
                      />
                      <button type="submit">
                        <FontAwesomeIcon icon={faCheck} />
                      </button>
                    </form>
                  ) : (
                    <>
                      {userdata.fullName}
                      <button onClick={() => setAppearInput(2)}>
                        <FontAwesomeIcon icon={faPenToSquare} />
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>Login Failed</>
        )}
      </div>
    </>
  );
}

export default Dashboard;
